import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import HubHeader from "@/components/HubHeader";
import { useApp } from "@/context/AppContext";
import { getUi } from "@/portal/portal";
import { getImageLibrary, imageUrl, LEGACY_PDF } from "@/lib/api";

export default function Library() {
  const { lang } = useApp();
  const t = getUi(lang);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getImageLibrary().then((d) => setGroups(d.groups || [])).finally(() => setLoading(false));
  }, []);

  return (
    <div className="rbl" data-testid="library-page">
      <HubHeader />
      <div className="rbl-wrap" style={{ paddingTop: 32, paddingBottom: 16 }}>
        <Link to="/" className="rbl-back" data-testid="library-back">{t("allSessions")}</Link>
        <h1 className="rbl-h1" style={{ fontSize: 40 }}>🖼️ {t("libraryTileTitle")}</h1>
        <p className="rbl-intro">{t("libraryIntro")}</p>
        <a className="rbl-btn" style={{ marginTop: 12 }} href={LEGACY_PDF.library(lang)} target="_blank" rel="noreferrer" data-testid="library-download">
          {t("libraryDownload")}
        </a>
      </div>
      <div className="rbl-wrap" style={{ paddingBottom: 50 }}>
        {loading && <div className="rbl-spinner" />}
        {!loading && groups.map((g) => (
          <div key={g.session} style={{ marginBottom: 36 }}>
            <h2 className="rbl-section-title">{t("sessionWord")} {String(g.session).padStart(2, "0")}</h2>
            <div className="rbl-gallery">
              {g.images.map((img) => (
                <figure key={img.id} style={{ margin: 0 }}>
                  <img src={imageUrl(img.id)} alt={img.title} loading="lazy" data-testid={`library-img-${img.id}`} />
                  <figcaption style={{ fontSize: 13, color: "#6b7180", marginTop: 6 }}>{img.title}</figcaption>
                </figure>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
